import type { LucideIcon } from 'lucide-react';
import type { CellTone } from '@features/workshop-plan/utils/plan-cell';

import { Cog, Square, Package, Hourglass, CircleCheck } from 'lucide-react';

/** Classes of each tone: waiting for the machine, on the machine, done (to take out of the workshop). */
export type ToneStyle = {
  /** Border color */
  border: string;
  /** Left band + tinted background of an occupied cell / of an active filter */
  band: string;
  bg: string;
  bgHover: string;
  bgActive: string;
};

export const TONE_STYLES: Record<CellTone, ToneStyle> = {
  waiting: {
    border: 'border-amber-500',
    band: 'border-l-amber-500',
    bg: 'bg-amber-500/14',
    bgHover: 'hover:bg-amber-500/24',
    bgActive: 'bg-amber-500/16',
  },
  inProgress: {
    border: 'border-cyan-500',
    band: 'border-l-cyan-500',
    bg: 'bg-cyan-500/14',
    bgHover: 'hover:bg-cyan-500/24',
    bgActive: 'bg-cyan-500/16',
  },
  finished: {
    border: 'border-green-500',
    band: 'border-l-green-500',
    bg: 'bg-green-500/14',
    bgHover: 'hover:bg-green-500/24',
    bgActive: 'bg-green-500/16',
  },
  other: {
    border: 'border-slate-500',
    band: 'border-l-slate-500',
    bg: 'bg-slate-500/14',
    bgHover: 'hover:bg-slate-500/24',
    bgActive: 'bg-slate-500/16',
  },
  empty: {
    border: 'border-border',
    band: 'border-l-border',
    bg: 'bg-muted-foreground/6',
    bgHover: 'hover:bg-muted-foreground/12',
    bgActive: 'bg-muted-foreground/12',
  },
};

/** The icon repeats the tone, so the cells can be told apart without the color. */
export const TONE_ICONS: Record<CellTone, LucideIcon> = {
  empty: Square,
  waiting: Hourglass,
  inProgress: Cog,
  finished: CircleCheck,
  other: Package,
};

/** Short wording of each tone, used by the legend and the cells. */
export const TONE_LABELS: Record<CellTone, string> = {
  empty: 'Libre',
  waiting: 'En attente',
  inProgress: 'En cours',
  finished: 'À sortir',
  other: 'Autre',
};
